import { useRoutes } from 'react-router-dom';

import AuthenticationRoutes from './AuthenticationRoutes';
import MdRoutes from './md/MdRoutes';
import retiredRoutes from './retiredRoutes';

export default function ThemeRoutes() {
    return useRoutes([MdRoutes(), AuthenticationRoutes, ...retiredRoutes]);
}
